import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPost } from './client'

/*
 * Versiunea si licentele aplicatiilor de business.
 *
 *   GET  /business-apps/versions              indicatorii din lista, pe aplicatie
 *   GET  /business-apps/{id}/versions         cardul "Versions & licenses"
 *   POST /business-apps/{id}/licenses         seats, type
 *   POST /business-apps/{id}/versions/adopt   versiunea de pe server trece in fisa
 */

export type VersionRelation = 'same' | 'older' | 'newer' | 'other' | 'unknown' | 'none'

export type LicenseState = 'unset' | 'unknown' | 'ok' | 'over' | 'unused'

export type AppLicenses = {
  ready: boolean
  seats: number | null
  type: string
  typeLabel: string
  installed: number | null
  unused: number | null
  excess: number | null
  state: LicenseState
}

export type VersionSignal = { level: 'info' | 'warn' | 'bad'; code: string; text: string }

export type AppVersionsCard = {
  ready: boolean
  message?: string
  appId: number
  canEdit: boolean
  licenseTypes: { value: string; label: string }[]
  catalog: { code: string; name: string } | null
  hasServerRules: boolean
  hasClientRules: boolean
  servers: { device: string; software: string; version: string; component: boolean }[]
  serverVersion: string | null
  recorded: string
  reference: string | null
  referenceFrom: 'server' | 'recorded' | null
  canAdopt: boolean
  clientSoftware: string
  workstations: number | null
  different: number
  older: number
  unknown: number
  distribution: { version: string; count: number; relation: VersionRelation; devices: string[] }[]
  licenses: AppLicenses
  signals: VersionSignal[]
}

export type AppVersionIndicator = {
  reference: string | null
  referenceFrom: 'server' | 'recorded' | null
  workstations: number | null
  different: number
  older: number
  seats: number | null
  installed: number | null
  licenseState: LicenseState
  unused: number | null
  excess: number | null
}

export type AppVersionsSummary = { ready: boolean; versions: Record<string, AppVersionIndicator> }

export type VersionsWritten = { status: 'OK' | 'ERROR'; message: string; version?: string }

export function appVersionsQuery(appId: number) {
  return queryOptions({
    queryKey: ['business-apps', 'versions', appId],
    queryFn: () => apiGet<AppVersionsCard>(`/business-apps/${appId}/versions`),
  })
}

export function appVersionsSummaryQuery() {
  return queryOptions({
    queryKey: ['business-apps', 'versions', 'summary'],
    queryFn: () => apiGet<AppVersionsSummary>('/business-apps/versions'),
  })
}

export function saveAppLicenses(appId: number, seats: string, type: string) {
  return apiPost<VersionsWritten>(`/business-apps/${appId}/licenses`, { seats, type })
}

export function adoptAppVersion(appId: number) {
  return apiPost<VersionsWritten>(`/business-apps/${appId}/versions/adopt`, {})
}
